<template>
  <div class="container" >
      <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
                <th>Property Id</th>
                <th>Property Name</th>
                <th>Config Status</th>
                <th>Widget Added</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in paginatedData" :key="config.property">
                <td>property {{config.property}}</td>
                <td>{{config.propertyname}}</td>
                <td >{{config.type}}</td>
                <td><span class="badge badge-success" v-if="config.widgetadded == 'Yes'">Yes</span> <span class="badge badge-danger" v-if="config.widgetadded == 'No'">No</span></td>
            </tr>
            </tbody>
        </table>
        </div>
         <div class="row pull-right section-content" v-if="pageCount > 1">
       <span @click="prevPage" style="margin-right:15px;cursor:pointer;"><i class="fa fa-angle-left" style="font-size:30px"></i></span> <span style="font-size:20px">{{currentPage}} / {{pageCount}}</span> <span @click="nextPage" style="margin-left:15px;cursor:pointer;"><i class="fa fa-angle-right" style="font-size:30px"></i></span>
     </div>

      <!-- {{}} -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      configs: [],
      size: 20,
      currentPage: 1
    }
  },
  created () {
    this.configs = process.env.API_URL
  },
  methods: {
    nextPage () {
      if (this.currentPage === this.pageCount) {
        this.currentPage = 1
      } else {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage === 1) {
        this.currentPage = this.pageCount
      } else {
        this.currentPage--
      }
    }
  },
  computed: {
    pageCount () {
      let l = this.allConfig.length
      let s = this.size
      return Math.ceil(l / s)
    },
    allConfig () {
      let generatedConfigs = []
      var allConfigs = Object.values(this.configs)

      allConfigs.forEach(array => {
        generatedConfigs.push(array)
      })
      return generatedConfigs
    },
    paginatedData () {
      return this.allConfig.slice((this.currentPage - 1) * this.size, this.currentPage * this.size)
    },
    totalPages () {
      return Math.ceil(this.allConfig.length / this.size)
    }
  }

}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/setUp.vue